import { Component, OnInit } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-paginator-spinner',
    templateUrl: './paginator-spinner.component.html',
    styleUrls: ['./paginator-spinner.component.scss'],
    imports: [MatProgressSpinner]
})
export class PaginatorSpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
